import React, { useEffect, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { ToastContainer } from "react-toastify";
import BackArrows from "../../Form/BackArrow/BackArrows";
import { interestLevel, statusIcons } from "../../../Enum/LeadEnumConstants";
import { BiSolidEdit } from "react-icons/bi";
import { MdCheckCircle, MdPending, MdCancel } from "react-icons/md";
import AutoMessageModel from "./AutoMessageModel";
import { getIcons } from "../../Constant/Constant";
import AutoMessageService from "../../Services/AutoMessageService";
import { MdOutlineDelete } from "react-icons/md";
import { showSuccessToast } from "../../Constant/Notification";

const AutoMessageMain = () => {
  const [selectedData, setSelectedData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const icons = getIcons();

  const [data, setData] = useState([]);

  const getData = async () => {
    try {
      const response = await AutoMessageService.getAutoMessage();
      setData(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const getBackgroundClass = (label) => {
    switch (label?.toLowerCase()) {
      case "gold":
        return "bg-gradient-to-b from-[#FFB947] to-[#ECCD90] bg-clip-text text-transparent";
      case "silver":
        return "bg-gradient-to-b from-[#B6B6B6] to-[#E8E8E8] bg-clip-text text-transparent";
      case "bronze":
        return "bg-gradient-to-b from-[#BA7E5E] via-[#FF9F6B] to-[#411904] bg-clip-text text-transparent";
      case "diamond":
        return "bg-gradient-to-b from-[#0563FF] to-[#4085F8] bg-clip-text text-transparent";
      default:
        return "text-black";
    }
  };

  const getStatusBgColor = (label) => {
    switch (label) {
      case "Fresh":
        return "bg-[#74F2C433] border-2 border-[#399E79]";
      case "Registered Client":
        return "bg-[#2280FF1A] border-2 border-[#2280FF]";
      case "Follow-up":
        return "bg-[#D2FAEC80] border-2 border-[#399E79]";
      case "Deal Lost":
        return "bg-[#FDB1B140] border-2 border-[#FDB1B1]";
      case "Not Interested":
        return "bg-[#FFBFA44D] border-2 border-[#FFBFA4]";
      case "Unanswered":
        return "bg-[#FFBFA44D] border-2 border-[#FFBFA4]";
      case "Retry Suitable":
        return "bg-[#74F2C433] border-2 border-[#399E79]";
      default:
        return "bg-[#74F2C433] border-2 border-[#399E79]";
    }
  };

  const getMetaApprovalStatus = (status) => {
    switch (status) {
      case "APPROVED":
        return {
          icon: <MdCheckCircle className="text-green-500 text-xl" />,
          text: "Approved",
          class: "text-customGreen",
        };
      case "PENDING":
        return {
          icon: <MdPending className="text-amber-500 text-xl" />,
          text: "Waiting for approving",
          class: "text-amber-500",
        };
      case "REJECTED":
        return {
          icon: <MdCancel className="text-red-500 text-xl" />,
          text: "Rejected",
          class: "text-red-500",
        };
      default:
        return {
          icon: <MdPending className="text-gray-500 text-xl" />,
          text: "Unknown",
          class: "text-gray-500",
        };
    }
  };

  const handleBack = () => {
    window?.history.back();
  };

  const handleMessage = (message) => {
    setIsOpen(true);
    console.log(message);
    setSelectedData(message?.id);
  };

  const handleCreateMessage = () => {
    setSelectedData(null);
    setIsOpen(true);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";

    const [datePart] = dateStr.split(" ");

    return datePart;
  };

  const handleDeleteMessage = async (item) =>{
    try {
      const body = {
        templateId : item?.id,
        waTemplateName : item?.waTemplateName,
      }
      const response = await AutoMessageService.deleteAutoMessage(body);
      if(response.status === 200){
      showSuccessToast("Message deleted successfully.");
      getData();
      }
      
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <>
      <div className="bg-appGrayBackground min-h-screen pb-16">
         <AdminAppBar />
        <ToastContainer />
        <div className="mt-20 pt-8 px-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-6">
              <BackArrows onClick={handleBack} />
              <h1 className="text-[32px] font-medium">Automated Messages</h1>
            </div>

            <button
              onClick={handleCreateMessage}
              className="bg-customGreen text-lg font-semibold w-[166px] h-[40px] text-white rounded-[10px] hover:bg-opacity-90 transition-all"
            >
              Create
            </button>
          </div>
        </div>

        <div className="px-6 mt-6">
          {loading ? (
            <div className="flex items-center justify-center h-[300px]">
              <div className="flex justify-center items-center h-full">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-customGreen"></div>
              </div>
            </div>
          ) : data?.length > 0 ? (
            <div className="bg-white p-5 rounded-lg shadow-md">
              <table className="w-full p-5 text-sm text-left text-gray-600">
                <thead className="text-xs font-semibold text-center text-gray-700 uppercase bg-gray-100 rounded-md">
                  <tr className="">
                    <th className="px-6 py-4">Automated Message</th>
                    <th className="px-6 py-4">Lead Status</th>
                    <th className="px-6 py-4">Lead Quality</th>
                    <th className="px-6 py-4">Created Date</th>
                    <th className="px-6 py-4">Meta Verification</th>
                    <th className="px-6 py-4">Status</th>

                    <th className="px-6 py-4">Action</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {data.map((item) => {
                    const leadStatus = item.leadStatus?.name || "Unknown";
                    const qualities = item.leadQualities || [];
                    const metaStatus = getMetaApprovalStatus(item.metaApproved);

                    return (
                      <tr
                        key={item.id}
                        className="hover:bg-gray-50 transition duration-150 ease-in-out"
                      >
                        <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">
                          {item.messageType?.name || item.messageType || "N/A"}
                        </td>
                        <td className="px-6 py-4">
                          {leadStatus !== "Unknown" ? (
                            <div
                              className={`${getStatusBgColor(
                                leadStatus
                              )} flex items-center w-44 mx-auto px-2 py-1 text-center justify-center gap-2 rounded-full`}
                            >
                              {statusIcons.find((s) => s.label === leadStatus)
                                ?.image && (
                                <img
                                  src={
                                    statusIcons.find(
                                      (s) => s.label === leadStatus
                                    )?.image
                                  }
                                  alt={leadStatus}
                                  className="w-5 h-5"
                                />
                              )}
                              <span className="text-gray-700">
                                {leadStatus}
                              </span>
                            </div>
                          ) : (
                            <span className="text-gray-500">Unknown</span>
                          )}
                        </td>
                        <td className="px-6 py-4">
                          {qualities.length > 0 ? (
                            <div className="flex justify-center cursor-pointer items-center gap-2 flex-wrap group relative">
                              <div className="flex items-center gap-1">
                                {interestLevel.find(
                                  (q) => q.label === qualities[0].name
                                )?.image && (
                                  <img
                                    src={
                                      interestLevel.find(
                                        (q) => q.label === qualities[0].name
                                      )?.image
                                    }
                                    alt={qualities[0].name}
                                    className="w-5 h-5"
                                  />
                                )}
                                <span
                                  className={getBackgroundClass(
                                    qualities[0].name
                                  )}
                                >
                                  {qualities[0].name}
                                </span>
                              </div>

                              {qualities.length > 1 && (
                                <div className="text-blue-500 text-sm">
                                  +{qualities.length - 1}
                                </div>
                              )}

                              <div className="hidden group-hover:flex flex-col w-36 absolute top-full mt-2 left-1/2 -translate-x-1/2 bg-white shadow-lg rounded-md p-3 z-30">
                                {qualities.map((quality, index) => (
                                  <div
                                    key={index}
                                    className="flex items-center gap-1"
                                  >
                                    {interestLevel.find(
                                      (q) => q.label === quality.name
                                    )?.image && (
                                      <img
                                        src={
                                          interestLevel.find(
                                            (q) => q.label === quality.name
                                          )?.image
                                        }
                                        alt={quality.name}
                                        className="w-5 h-5"
                                      />
                                    )}
                                    <span
                                      className={getBackgroundClass(
                                        quality.name
                                      )}
                                    >
                                      {quality.name}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ) : (
                            <span className="text-gray-400">None</span>
                          )}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {formatDate(item.createdTimestamp)}
                        </td>
                        <td className="px-6 py-4">
                          <div className="flex items-center justify-center gap-2">
                            {metaStatus.icon}
                            <span className={metaStatus.class}>
                              {metaStatus.text}
                            </span>
                          </div>
                        </td>
                        <td className="px-6 py-4">
                          <div className="flex  text-center justify-center">
                            <span
                              className={`px-4 py-2 w-24 rounded-md text-sm font-semibold ${
                                item.active
                                  ? "bg-gradient-to-r from-green-400 to-green-600 text-white shadow transform transition-all duration-300 hover:scale-105 hover:shadow-lg"
                                  : "bg-gradient-to-r from-red-400 to-red-600 text-white shadow-md transform transition-all duration-300 hover:scale-105 hover:shadow-lg"
                              }`}
                            >
                              {item.active ? "Active" : "Deactive"}
                            </span>
                          </div>
                        </td>

                        <td className="px-6 py-4">
                         <div className="flex items-center justify-center gap-2">
                         <button
                            onClick={() => handleMessage(item)}
                            className="text-blue-500 bg-blue-100 rounded-full px-1 py-1  hover:text-blue-700 flex justify-center items-center "
                          >
                            <BiSolidEdit className="text-xl" />
                          </button>
                          <button
                            onClick={() => handleDeleteMessage(item)}
                            className="text-red-500 flex bg-red-100 rounded-full px-1 py-1  justify-center items-center "
                          >
                            <MdOutlineDelete className="text-xl" />
                          </button>
                         </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="flex bg-white rounded-lg flex-col items-center justify-center h-[60vh]">
              <div className="w-full flex flex-col items-center justify-center">
                <h1 className="text-2xl font-medium text-customGreen mb-6 mt-7">
                  Create Automated Message
                </h1>
                <img
                  src={icons?.autoEmpty}
                  alt="No messages"
                  className="w-96 h-auto"
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <AutoMessageModel
        selectedDataId={selectedData}
        isOpen={isOpen}
        close={() => {
          setIsOpen(false);
          setSelectedData(null);
          getData();
        }}
      />
    </>
  );
};

export default AutoMessageMain;
